import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CreditCard } from 'data/shared/CreditCard';

const DELIMITER = '|'

export const useCreditCardState: () => [CreditCard[], Dispatch<SetStateAction<CreditCard[]>>] = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCards = (searchParams.get('cards')?.split(DELIMITER)  ?? []) as CreditCard[]

  const [creditCards, setCreditCards] = useState<CreditCard[]>(initialCards)

  useEffect(() => {
    if (creditCards.length > 0) {
      searchParams.set('cards', creditCards.join(DELIMITER));
    } else {
      searchParams.delete('cards');
    }
    setSearchParams(searchParams);
  }, [creditCards, searchParams, setSearchParams]);

  return [
    creditCards, setCreditCards
  ]
}